<template>
  <div id="BITS-member" class="bits">
    <div v-loading="!ready" v-if="!ready" class="page-loader">

    </div>
    <router-view v-else></router-view>

    

    

  </div>
 
</template>

<script>
  
  export default {
    name: 'app',
    data() {
      return {        
        error: null,
        ready: false
      }
    },

    async created() {
      await this.loadRequiredAssets();
    },
    
    methods: {
            
      async loadRequiredAssets() {

        await this.$store.dispatch("fetchUserInfo");        
        await this.$nextTick();
        setTimeout(() => {
          this.ready = true;
        }, 1000);
        
      }

      
    },

    components: {
      
    },
    $_veeValidate: {
      validator: 'new' 
    }    

  }
</script>

<style lang="scss">

  .el-dialog.sidebar-visible {
    left: 160px;
  }

  body.personabar-visible .wrapper {
    margin-left: 80px;
  }

  body.personabar-visible .sidebar {
    margin-left: 80px;
  }

  .page-loader {
    margin-top: 30vh;
  }

  .form-group.has-error {
    input[type='text'], select {
      border-color: #FB404B;
    }
    label { color: #FB404B }
  }

</style>



